import React from 'react';

import { DisplayButton } from '@xo-union/tk-ui-links';
import { EventQuestions } from './EventQuestions';
import { GeneralQuestions } from './GeneralQuestions';
import { GuestWedding } from '../GuestWeddingTypes';

import { EventType } from '../EventTypes';
import styles from './eipSection.scss';

interface Props {
  guestWedding?: GuestWedding;
  events?: EventType[];
  onClickEditForm?: () => void;
  openEventModal?: (id: string) => void;
}
export const RSVPForm: React.FC<Props> = ({ guestWedding, events, onClickEditForm, openEventModal }) => {
  return (
    <>
      <EventQuestions events={events} openEventModal={openEventModal} />
      <GeneralQuestions guestWedding={guestWedding} />

      <DisplayButton className={styles.link} onClick={onClickEditForm} color="primary" size="md" iconName="edit">
        Edit Form
      </DisplayButton>
    </>
  );
};
